const luckysheetConfigsetting = {
  autoFormatw: false,
  accuracy: undefined,
  total: 0,
  allowCopy: true,
  showtoolbar: true,
  showinfobar: true,
  showsheetbar: true,
  showstatisticBar: true,
  pointEdit: false,
  pointEditUpdate: null,
  pointEditZoom: 1,
  userInfo: false,
  userMenuItem: [],
  myFolderUrl: null,
  functionButton: null,
  showConfigWindowResize: true,
  enableAddRow: true,
  addRowCount: 100,
  enableAddBackTop: true,
  enablePage: true,
  pageInfo: null,
  editMode: false,
  beforeCreateDom: null,
  workbookCreateBefore: null,
  workbookCreateAfter: null,
  remoteFunction: null,
  fireMousedown: null,
  plugins: [],
  forceCalculation: false, //强制刷新公式，公式较多会有性能问题，慎用
  defaultColWidth: 73,
  defaultRowHeight: 19,
  defaultTextColor: "#000", // 默认文字颜色
  defaultCellColor: "#fff", // 默认单元格背景颜色
  defaultHighlightColor: "rgba(76, 76, 76, 0.1)", // 默认行列标题高亮颜色
  defaultTitleBorderColor: "#EBEBEB", // 默认标题边框颜色
};

export default luckysheetConfigsetting;
